import LogoutCountdown from "components/common/logoutCountDown";
import React, { useEffect, useRef, useState } from "react";
import { userLogout } from "utils/AuthUtils";
import { IDLE_TIMEOUT, refreshTokenTimer } from "utils/CommonConstants";
import { refreshToken } from "utils/CommonFunctions";
// import ss from '../../../Worker/activityWorker'

const ActivityCheck: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [activityTimer, setActivityTimer] = useState(0); // Tracks user activity time
  const [countdown, setCountdown] = useState(120); // Countdown timer for 2-minute logout warning
  const activityIntervalRef = useRef<Worker | null>(null);
  const countdownIntervalRef = useRef<Worker | null>(null);
  const refreshIntervalRef = useRef<Worker | null>(null);
  const resetTimers = () => {
    setActivityTimer(0); // Reset activity timer
    setCountdown(120); // Reset countdown for the popup
    setOpen(false); // Close the popup if it is open

    // const now = Date.now();
    // const intervalTime = now + IDLE_TIMEOUT * 60 * 1000;
    // localStorage.setItem("logoutTimer", intervalTime.toString());

    // Stop countdown interval if running
    if (countdownIntervalRef.current) {
      countdownIntervalRef.current.postMessage({ action: "stop" });
    }
  };

  const handleUserActivity = () => {
    setActivityTimer(0); // Reset activity timer on user interaction
    resetTimers(); // Reset countdown if popup is open
  };

  const handleUserActivityByEvents = () => {
    setActivityTimer(0); // Reset activity timer on user interaction
    resetTimers(); // Reset countdown if popup is open
  };

  useEffect(() => {
    const suppressEvents = (e: Event) => {
      const targetElement = e.target as HTMLElement;
      const isExtendButtonTriggred = document.querySelector(".extend-button")?.contains(targetElement);
      const isCloseButtonTriggred = document.querySelector(".logout-close")?.contains(targetElement);

      if (isExtendButtonTriggred || isCloseButtonTriggred) {
        return;
      } else if (open) {
        e.stopPropagation();
        e.preventDefault();
      }
    };

    const handleGlobalActivity = () => {
      if (!open) {
        handleUserActivityByEvents(); // Reset timer only if the popup is closed
      }
    };

    // Attach event listeners to suppress events when the popup is open
    if (open) {
      window.addEventListener("click", suppressEvents, true);
      window.addEventListener("scroll", suppressEvents, true);
      window.addEventListener("load", suppressEvents, true);
    } else {
      window.addEventListener("click", handleGlobalActivity);
      window.addEventListener("scroll", handleGlobalActivity);
      window.addEventListener("load", handleGlobalActivity);
    }

    // Cleanup listeners on component unmount
    return () => {
      window.removeEventListener("click", suppressEvents, true);
      window.removeEventListener("scroll", suppressEvents, true);
      window.removeEventListener("load", suppressEvents, true);

      window.removeEventListener("click", handleGlobalActivity);
      window.removeEventListener("scroll", handleGlobalActivity);
      window.removeEventListener("load", handleGlobalActivity);
    };
  }, [open]);

  // const handleActivity = () => {
  //   const logoutTimer = localStorage.getItem("logoutTimer");
  //   if (logoutTimer) {
  //     const parsedLogoutTimer = parseFloat(logoutTimer);
  //     if (Date.now() > parsedLogoutTimer) {
  //       logoutUser();
  //     } else {
  //       resetTimers();
  //     }
  //   }
  // };

  // useEffect(() => {
  //   window.addEventListener("visibilitychange", handleActivity);

  //   return () => {
  //     window.removeEventListener("visibilitychange", handleActivity);
  //   };
  // }, []);

  // This useEffect sets up a mechanism to periodically refresh the authentication token
  // to maintain the user session. It initializes the token refresh on component mount
  // and continues refreshing it at specified intervals. The interval is cleaned up
  // when the component unmounts to prevent memory leaks.
  useEffect(() => {
    refreshIntervalRef.current = new Worker(new URL("../../../Worker/activityWorker.ts", import.meta.url), {
      type: "module"
    });

    refreshIntervalRef.current.onmessage = () => {
      refreshToken();
    };

    refreshIntervalRef.current.postMessage({ action: "start", interval: refreshTokenTimer });

    return () => {
      refreshIntervalRef.current?.postMessage({ action: "stop" });
      refreshIntervalRef.current?.terminate();
    };
  }, []);

  useEffect(() => {
    // Initialize the activity worker
    activityIntervalRef.current = new Worker(new URL("../../../Worker/activityWorker.ts", import.meta.url), {
      type: "module"
    });

    // Handle ticks from the activity worker
    activityIntervalRef.current.onmessage = () => {
      setActivityTimer((prev) => prev + 1);
    };

    // Start the activity worker
    activityIntervalRef.current.postMessage({ action: "start", interval: 1000 });

    return () => {
      // Stop and terminate the activity worker on cleanup
      activityIntervalRef.current?.postMessage({ action: "stop" });
      activityIntervalRef.current?.terminate();
    };
  }, []);

  useEffect(() => {
    if (IDLE_TIMEOUT * 60 - activityTimer <= 120 && !open) {
      setOpen(true);

      // Initialize the countdown worker
      // workers / activityWorker.ts;
      countdownIntervalRef.current = new Worker(new URL("../../../Worker/activityWorker.ts", import.meta.url), {
        type: "module"
      });

      // Handle ticks from the countdown worker
      countdownIntervalRef.current.onmessage = () => {
        setCountdown((prev) => {
          if (prev <= 1) {
            logoutUser();
            return 0;
          }
          return prev - 1;
        });
      };

      // Start the countdown worker
      countdownIntervalRef.current.postMessage({ action: "start", interval: 1000 });
    }
  }, [activityTimer, open]);

  const logoutUser = () => {
    // Perform logout action here
    console.log("logout");
    resetTimers();
    setOpen(false);
    // setTimeout(() => {
    //   alert("You've been logged out!");
    userLogout();
    // }, 100);
  };
  return <> {open && <LogoutCountdown onClose={handleUserActivity} open={open} countdown={countdown} />}</>;
};

export default React.memo(ActivityCheck);
